// extracted by mini-css-extract-plugin
module.exports = {"header":"CrowdList-module__header___3xwLq","row":"CrowdList-module__row___p093o","moreButton":"CrowdList-module__moreButton___2UZAN"};